<script setup lang="ts">
import { useMediaQuery } from '@vueuse/core'
import { watch } from 'vue'

import { useSidebarState } from '@/hooks'

/**
 * This dummy component watches the active breadcrumb and closes the sidebar when it changes
 */
const props = defineProps<{
  breadcrumb: string
}>()

const { toggleSidebar, sidebarState } = useSidebarState()
const isMobile = useMediaQuery('(max-width: 1000px)')

watch(
  () => props.breadcrumb,
  (n, o) => {
    if (n !== o && isMobile.value && sidebarState.showSidebar) toggleSidebar()
  },
)
</script>
<template>
  <slot />
</template>
